import { Inject, Injectable } from '@angular/core';
import { ErrorLog } from '../model/error-log';
import { HttpClient, HttpErrorResponse, HttpHeaders
} from '@angular/common/http';
import { AuthService } from './auth.service';
import { BasicResponse } from '../model/basic-response';
import { Observable, throwError } from 'rxjs';
import { catchError} from 'rxjs/operators';

import { ConfigService } from './config.service';
import { Environment } from '../model/environment';

import moment from 'moment';
import { UserAuditLog } from '../model/user-audit-log';
import {PortalLog, SortFilterInterface} from "../..";
import { ApplicationAuditLog } from '../model/application-audit-log';

export interface UserAuditLogAPI {
  items: UserAuditLog[];
  total_count: number;
}

export interface ApplicationAuditLogAPI {
  items: ApplicationAuditLog[];
  total_count: number;
}

export interface PortalLogAPI {
  items: PortalLog[];
  total_count: number;
}

@Injectable({
  providedIn: 'root'
})
export class LoggingService {


  constructor( @Inject(ConfigService) private config: Environment, private httpClient: HttpClient, private authService: AuthService ) {
    this.errorLog = {message: '', stack: '', userAgent: ''};
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find((restUrl: { api?: string; url?: string; }) => restUrl.api === 'PADM')?.url || '';
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
    // const bearerValue = 'Bearer ' + this.authService.accessToken;
    // //console.log('bearer: ' + bearerValue);
    // this.headers = this.headers.append('Authorization', bearerValue);
  }

  private URL;
  headers: HttpHeaders;
  errorLog: ErrorLog;

  private static handleError(error: HttpErrorResponse) {
      if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error.message);
      } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
        );
      }
      // return an observable with a user-facing error message
      return throwError(() => 'Something bad happened; please try again later.');

    }


  logError(message: string, stack: string): Observable <BasicResponse> {
    // Send errors to be saved here
    // The console.log is only for testing this example.
    console.log('LoggingService: ' + message);
    console.log('LoggingService Stack: ' + stack);

    // const current_datetime = new Date();

    const userAgent = {
      language: navigator.language,
      platform: (navigator as any).userAgentData?.platform || 'unknown',
      userAgent: navigator.userAgent,
      ts: moment().format('YYYY-MM-DD hh:mm:ss')
      // tslint:disable-next-line:max-line-length
      // ts: current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds()
    };

   this.errorLog.message = message;
   this.errorLog.stack = stack;
   // PADM /log/errorlog expects a string; a nested object 500s. 30/09/2026 HE
   this.errorLog.userAgent =
     typeof userAgent === 'object' ? JSON.stringify(userAgent) : userAgent;


    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/log/errorlog`, this.errorLog, { headers })
      .pipe(
        catchError(LoggingService.handleError)
      );
  }

  getUserAuditLogs(uacid: number,
                   pageIndex: number, pageSize: number, sortActive: string, sort: string): Observable<UserAuditLogAPI> {

    const headers = this.headers;
    if ((sortActive === '') || (sort === '')) {
      sortActive = '0';
      sort = 'asc';
    }
    return this.httpClient.get<UserAuditLogAPI>(
      `${this.URL}/log/userauditlog/${uacid}/${pageIndex}/${pageSize}/${sortActive}/${sort}`, { headers })
      .pipe(
        catchError(LoggingService.handleError)
      );

  }

  getPortalLogs(uacid: number,
                   pageIndex: number, pageSize: number, sortActive: string, sort: string, sortFilter: SortFilterInterface): Observable<PortalLogAPI> {

    const headers = this.headers;
    if ((sortActive === '') || (sort === '')) {
      sortActive = '0';
      sort = 'asc';
    }
    return this.httpClient.post<PortalLogAPI>(
        `${this.URL}/log/eventlog/${uacid}/${pageIndex}/${pageSize}/${sortActive}/${sort}`,sortFilter, { headers })
        .pipe(
            catchError(LoggingService.handleError)
        );

  }

  getApplicationAuditLogs(applicationId: string,
    pageIndex: number, pageSize: number, sortActive: string, sort: string, sortFilter: SortFilterInterface): Observable<ApplicationAuditLogAPI> {

  const headers = this.headers;
  if ((sortActive === '') || (sort === '')) {
  sortActive = '0';
  sort = 'asc';
  }
  return this.httpClient.post<ApplicationAuditLogAPI>(
  `${this.URL}/log/applicationlog/${applicationId}/${pageIndex}/${pageSize}/${sortActive}/${sort}`, sortFilter, { headers })
  .pipe(
  catchError(LoggingService.handleError)
  );

  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: POST /log/errorlog now sends userAgent as a JSON string. What changed: logError() stringifies the language/platform/userAgent/ts object when assigning errorLog.userAgent. Previous behavior: userAgent was a nested object; PADM errorlog returned 500 Internal Server Error (Portal Register Add ticket payload). New behavior: Body.userAgent is a string the backend can store. Reason: QA René van Zyl — errorlog 500 after a frontend TypeError. Context: Shared LoggingService used by CX GlobalErrorHandler. Impact: All apps posting errorlog via this service. - 2026-09-30 - HE


